import con from '@services/connection'
import { portfolioComparePdf as endpoint } from '../constants/URL'

class APIConsolidatorPortfolioComparePdf {
  async comparar({ idCliente, file, assetsStatistics } = {}) {
    const data = {
      file,
      assets_statistics: JSON.stringify(assetsStatistics),
    }
    const r = await con.post(endpoint.compare(idCliente), data)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }
}

export const apiConsolidatorPortfolioComparePdf =
  new APIConsolidatorPortfolioComparePdf()
